/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReintegrate200,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate401,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate404,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate500,
  PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams,
  PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReintegrate.ts";

export const postApiV1IndividualpaymentParcelsParcelidReintegratePathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams>;

export const postApiV1IndividualpaymentParcelsParcelidReintegrateQueryParamsSchema =
  z
    .object({
      serial: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidReintegrate200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrate200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidReintegrate401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrate401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1IndividualpaymentParcelsParcelidReintegrate404Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidReintegrate500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrate500>;

export const postApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidReintegrate200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse>;
